<template>
  <header>
    <img src="../../assets/img/logo.png" alt="" class="logo">
    <span class="logo_title"">习习教师</span>
    <div class="meun">
      <ul>
        <!-- <li>
          <router-link to="" class="active">个人</router-link>
        </li>
        <li>
          <router-link to="">班级</router-link>
        </li>
        <li>
          <router-link to="">学校</router-link>
        </li> -->
      </ul>
    </div>
    <div class="user">
      <!-- <img src="../../assets/img/message-icon.png" alt="" class="mesg"> -->
      <div class="personal">
        <img :src="userInformation.avatar" alt="" v-if="userInformation.avatar" class="profile">
        <em></em>
        <div class="exit">
          <ul>
            <li @click="goPersonal">
              <img src="../../assets/img/personal-icon.png" alt="">
              <span>个人中心</span>
            </li>
            <li @click="logout">
              <img src="../../assets/img/warn.png" alt="">
              <span>退出登录</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <notice :params="params" :isNotice="isNotice" @isConfirm="isConfirm"></notice>
  </header>
</template>

<script>
import fetch from "./../../fetch";
import { mapGetters, mapActions } from "vuex";
import notice from "./../notice/notice.vue";

export default {
  data() {
    return {
      userInformation: this.getUser(),
      isNotice: false,
      params: {},
      initLogo: "static/img/photo.png"
    };
  },
  created() {
    this.$nextTick(() => {
      this.userInf();
    });
  },
  components: {
    notice
  },
  methods: {
    ...mapGetters(["getUser"]),
    ...mapActions(["setUser", "removeUser"]),

    goPersonal() {
      let userId = JSON.parse(window.localStorage.user).userId.toString();
      this.$router.push({ path: "/web/personMsg/" + userId });
    },

    // 退出登录
    logout() {
      this.isNotice = !this.isNotice;
      this.params = {
        type: 1,
        noticeText: "确认退出账号登录!",
        noticeTitle: "确认退出"
      };
    },
    isConfirm(val) {
      if (val) {
        window.localStorage.setItem(
          "Checked",
          JSON.stringify({ isChecked: false })
        );
        this.userInformation = {};
        this.removeUser();
        window.localStorage.removeItem("user");
        window.localStorage.removeItem("basicData");
        window.sessionStorage.removeItem("studentsTemp");
        window.sessionStorage.removeItem("studentsListData");
        let url = window.location.href;
        if (/\.my\./.test(url)) {
          window.location.assign(window.location.origin);
        } else {
          window.location.assign("#/login");
        }
      }
    },
    userInf() {
      this.userInformation = this.getUser();
      this.userInformation.avatar =
        this.userInformation.avatar || this.initLogo;
    },

    // 获取系统消息
    getData() {
      fetch.getSystemMessages(this.param).then(res => {
        if (!res) {
          return;
        }
        this.arr = res.data.pageList;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// topBanner.vue?5b9cef82